<template>
    <div class="newPage">
        <div class="form">
            <div class="formItem">
                <div class="itemLabel">城市</div>
                <div class="itemValue">
                    <el-cascader
                            v-model="stepsForm.citys"
                            :options="cityList"
                            :props="{
                                        multiple: false,
                                        label:'lable',
                                        value:'lable'
                                    }"
                            size="small"
                            clearable
                    ></el-cascader>
                </div>
            </div>
            <div class="formItem">
                <div class="itemLabel">数据类别</div>
                <div class="itemValue">
                    <el-select v-model="stepsForm.type" size="small" placeholder="请选择" >
                        <el-option label="小时数据" :value="0"></el-option>
                        <el-option label="日数据" :value="1"></el-option>
                        <el-option label="月数据" :value="2"></el-option>
                        <el-option label="年数据" :value="3"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="formItem">
                <div class="itemLabel">数据类型</div>
                <div class="itemValue">
                    <el-select v-model="stepsForm.mapperId" size="small" placeholder="请选择" value-key="mapperId">
                        <el-option v-for="item in typeList" :label="item.name" :value="item.mapperId"
                                   :key="item.mapperId"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="formItem">
                <div class="itemLabel">时间范围</div>
                <div class="itemValue">
                    <el-date-picker
                            v-model="stepsForm.time"
                            type="daterange"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </div>
            </div>
            <div class="formItem">
                <el-button size="small" type="primary" @click="getData"> 查询</el-button>
                <el-button size="small" type="primary" v-if="tableData && tableData.list.length" @click="exportData"> 导出</el-button>
            </div>
        </div>
        <div class="content">
            <div class="table" v-if="tableData">
                <el-table
                        :data="tableData.list"
                        :header-cell-style="{background:'#e0e0e0',color:'#000'}"
                        style="width: 100%">
                    <el-table-column
                            v-for="(item,index) in headerList"
                            :key="index"
                            :prop="item.mappedField"
                            :label="item.mappedFieldName"
                            :fixed="item.position ? true: false"
                            width="180"
                            show-overflow-tooltip
                            align="center"
                          >
                    </el-table-column>
                </el-table>

                <pagination
                        v-show="tableData.totalCount>stepsForm.pageSize"
                        :total="tableData.totalCount"
                        :page.sync="stepsForm.page"
                        :limit.sync="stepsForm.pageSize"
                        @pagination="getList"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import url from "../../../utils/UrlApi"
    import exportFile from "../../../utils/exportFile"

    export default {
        name: "dataFind",
        data(){
            return {
                stepsForm:{
                    page:1,
                    pageSize:10,
                    type:0,
                },
                typeList:[],
                cityList:[],
                headerList:[],
                tableData:{
                    list:[],
                    totalCount:0
                },
            }
        },
        mounted(){
          this.getCityList()
          this.getDataType()
        },
        methods:{

            getData(){
               this.getHeaderList()
            },


            getList(){
                const loading = this.$loading({
                    lock: true,
                    text: '请求中...',
                    spinner: 'el-icon-loading',
                });
                let data = {
                    pageSize:this.stepsForm.pageSize,
                    page:this.stepsForm.page,
                    province:this.stepsForm.citys ? this.stepsForm.citys[0] :'',
                    city:this.stepsForm.citys ? this.stepsForm.citys[1] :'',
                    startTime:this.stepsForm.time ?this.stepsForm.time[0] :'',
                    endTime:this.stepsForm.time ?this.stepsForm.time[1]:'',
                    mapperId:this.stepsForm.mapperId,
                    type:this.stepsForm.type,
                }
                this.$http.get(url.DataSourceAnalysislist, {
                    params: data
                }).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            exportData(){

                let data = {
                    pageSize:this.stepsForm.pageSize,
                    page:this.stepsForm.page,
                    province:this.stepsForm.citys ? this.stepsForm.citys[0] :'',
                    city:this.stepsForm.citys ? this.stepsForm.citys[1] :'',
                    startTime:this.stepsForm.time ?this.stepsForm.time[0] :'',
                    endTime:this.stepsForm.time ?this.stepsForm.time[1]:'',
                    mapperId:this.stepsForm.mapperId,
                    type:this.stepsForm.type,
                }
                this.$http.get(url.DataSourceAnalysisexport, {
                    params: data,responseType: "arraybuffer"
                }).then(res => {
                    // console.log(res)
                    // if (res.data.code === '200') {
                    //     console.log(res)
                        exportFile.getExcel(res.data,  decodeURI(res.headers.name))
                        // this.tableData = res.data.data
                    // } else {
                    //     this.$message.error(res.data.message)
                    // }
                })
            },

            getHeaderList(){
                if(!this.stepsForm.mapperId){
                    this.$message.error('请选择数据类型')
                    return
                }

                if(!this.stepsForm.time){
                    this.$message.error('请选择时间范围')
                    return
                }
                let data = {
                    mapperId:this.stepsForm.mapperId
                }
                this.$http.get(url.DataSourceAnalysisfieldList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.headerList = res.data.data
                        this.getList()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getDataType(){
                let data = {}
                this.$http.get(url.maperTablelist, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.typeList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .newPage{
        padding: 10px;
        .form{
            display: flex;
            flex-wrap: wrap;
            .formItem{
                margin-right: 10px;
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                .itemLabel{
                    color: #000;
                    font-size: 14px;
                    padding: 0 10px;
                }
                .itemValue{}
            }
        }
    }
</style>
